import dayjs from 'dayjs'

/**
 * Durasi shift dari `start` sampai `end` (dayjs), mis. "1 Hari 2 Jam 5 Menit".
 * Logika sama dengan `shiftDurationText` di CloseShift. Kosong bila `start` tidak valid.
 */
export const formatShiftDuration = (start, end, formatMessage) => {
  if (!start) {
    return ''
  }
  const startDate = dayjs(start)
  if (!startDate.isValid()) {
    return ''
  }
  const diff = end.diff(startDate)
  if (diff < 0) {
    return ''
  }

  const dur = dayjs.duration(diff)
  const days = Math.floor(dur.asDays())
  const hours = dur.hours()
  const minutes = dur.minutes()

  const parts = []
  if (days > 0) {
    parts.push(`${days} ${formatMessage({ id: days === 1 ? 'date.day' : 'date.days' })}`)
  }
  if (hours > 0) {
    parts.push(`${hours} ${formatMessage({ id: hours === 1 ? 'date.hour' : 'date.hours' })}`)
  }
  if (minutes > 0 || parts.length === 0) {
    parts.push(
      `${minutes} ${formatMessage({ id: minutes === 1 ? 'date.minute' : 'date.minutes' })}`,
    )
  }
  return parts.join(' ')
}
